import React from 'react';

import dayjs from 'dayjs';

import ContentCard from '../../../components/ContentCard';
import DataGrid from '../../../components/DataGrid';
import { NoContentMessage } from '../../../components/PageLayout';
import SkeletonStack from '../../../components/SkeletonStack';
import { useGetExamAttemptsByUserQuery } from '../../../services/exams';
import { ExamAttempt } from '../../../services/exams/types';
import { useGetStudentAnalyticsQuery } from '../../../services/students';
import {
  ContentContainer,
} from '../index.styles';

interface ExamsTabProps {
  subject: string,
  studentId: string,
}

const ExamsTab = ({ subject, studentId }: ExamsTabProps) => {
  /**
   * Categories Queries & Mutations
   */
  const { data: analyticsData,
    isFetching: isAnalyticsLoading,
    isError: isAnalyticsError } = useGetStudentAnalyticsQuery({
    studentId, subject,
  }, { skip: !subject || subject === '' });

  const { data: markedExams, isFetching: isMarkedExamsLoading } = useGetExamAttemptsByUserQuery({
    student: studentId, subject, marked: true,
  }, { skip: !subject || subject === '' });

  return (
    (isAnalyticsLoading || isMarkedExamsLoading) ? (
      <SkeletonStack />
    ) : (
      <ContentContainer>
        {analyticsData?.analytics && !isAnalyticsError ? (
          <ContentCard variant="outlined" title="Marked Exams">
            <DataGrid
              rows={markedExams?.data || []}
              initialState={{
                sorting: {
                  sortModel: [{ field: 'markedDatetime', sort: 'desc' }],
                },
              }}
              columns={[
                {
                  field: 'markedDatetime',
                  headerName: 'Date',
                  width: 120,
                  renderCell: (e: any) => dayjs(e.value).format('D-MMM'),
                },
                {
                  field: 'examLabel',
                  headerName: 'Exam',
                  width: 240,
                },
                {
                  field: 'outcome',
                  headerName: 'Mark',
                  width: 120,
                  renderCell: (e: any) => (`${Math.round(e.value * 100)}%`),
                },
              ]}
              getRowId={(e) => `${e.student}#${e.examId}#${e.attemptNumber}`}
              getRowHref={(row: ExamAttempt) => `/analytics/${subject}/${row.examId}/${row.student}/${row.attemptNumber}`}
            />
          </ContentCard>
        ) : (
          <NoContentMessage />
        )}
      </ContentContainer>
    )
  );
};
export default ExamsTab;
